import MDTypography from 'src/components/md/MDTypography';
import {
  CircularProgress,
  Box,
  ListItem,
  ListItemButton,
  ListItemText,
  Radio,
} from '@mui/material';
import { Icon } from '@mui/material';

import useProductVariant from 'src/api/inventory-management/products/useProductVariant';

// New product variant list item component
const ProductVariantListItem: React.FC<{
  variantId: string;
  isSelected: boolean;
  onSelect: (variantId: string, productId: string) => void;
}> = ({ variantId, isSelected, onSelect }) => {
  const { data, isLoading, error } = useProductVariant(variantId);

  const productVariant = data?.productVariant;

  return (
    <ListItem key={variantId} dense divider disablePadding>
      <ListItemButton
        onClick={() => {
          if (productVariant) {
            onSelect(productVariant.id, productVariant.productId);
          }
        }}
      >
        <Radio checked={isSelected} />
        {isLoading ? (
          <Box display="flex" alignItems="center" py={1} ml={2}>
            <CircularProgress size={20} />
            <MDTypography variant="body2" ml={2}>
              Loading variant information...
            </MDTypography>
          </Box>
        ) : error ? (
          <Box display="flex" alignItems="center" py={1} ml={2}>
            <Icon sx={{ color: 'error.main', mr: 1 }}>error_outline</Icon>
            <MDTypography variant="body2" color="error.main">
              {error.message || 'Error loading variant'}
            </MDTypography>
          </Box>
        ) : productVariant ? (
          <Box display="flex" alignItems="center" width="100%">
            <ListItemText
              primary={
                (productVariant.originMetadata?.NAMEINVC as string) ||
                '(No name)'
              }
            />
          </Box>
        ) : (
          <ListItemText primary="Variant not found" />
        )}
      </ListItemButton>
    </ListItem>
  );
};

export default ProductVariantListItem;
